import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const BurgerIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('BurgerIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 16"
    data-track-tag={dataTrackTag}
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.25 2.094h13.5M1.25 8h13.5m-13.5 5.906h13.5"
    />
  </svg>
);
BurgerIcon.id = 'BurgerIcon';
BurgerIcon.displayName = 'BurgerIcon';
export default BurgerIcon;
